import { render } from "./BaseTextarea.vue?vue&type=template&id=1884b0d4"
import script from "./BaseTextarea.vue?vue&type=script&lang=js"
export * from "./BaseTextarea.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BaseTextarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1884b0d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1884b0d4', __exports__)) {
    console.log('reload')
    api.reload('1884b0d4', __exports__)
  }
  
  module.hot.accept("./BaseTextarea.vue?vue&type=template&id=1884b0d4", () => {
    console.log('re-render')
    api.rerender('1884b0d4', render)
  })

}


export default __exports__